import { ElementRef } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { shareReplay } from 'rxjs/operators';
import { DATA_EXPORT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FACTOR_ANALYSIS_ATTRIBUTION_PERIODICITY_OPTIONS } from 'SecuritiesApp/ts/constants/attribution.constants';
import { ATTRIBUTION_OPTIONS } from 'SecuritiesApp/ts/features/attribution-factor-analysis/attribution-bar-chart-constants';
import { PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { PdfTitleModalComponent } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.component';
import { downloadUrl } from 'NewAngular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "NewAngular/features/components/modals/loading-modal/loading-modal.component";
import * as i6 from "NewAngular/features/components/pdf-title-modal/pdf-title-modal.component";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/inputs/radio-button-group/radio-button-group.component";
import * as i8 from "./attribution-factor-bar-chart/attribution-factor-bar-chart.component";
import * as i9 from "./attribution-factor-profile/attribution-factor-profile.component";
import * as i10 from "SecuritiesApp/ts/features/attribution-factor-analysis/components/attribution-factor-scatter-plot/attribution-factor-scatter-plot.component";
const _c0 = ["pdfTitleModal"];
const _c1 = a0 => ({ open: a0 });
export class AttributionFactorAnalysisComponent {
    constructor(eltRef, securitiesService, featureService) {
        this.eltRef = eltRef;
        this.securitiesService = securitiesService;
        this.featureService = featureService;
        this.hasExportFeature = false;
        this.exportLoading = false;
        this.loading = true;
        this.fetchSubscription = null;
        // Module data
        this.factorCoefficientRangeData = [];
        this.categoryGroupName = '';
        this.attributionBarChartData = { barChartData: [], coefficients: [], cssClasses: [] };
        // Attribution Mode
        this.ATTRIBUTION_OPTIONS = ATTRIBUTION_OPTIONS;
        this.selectedAttribution = this.ATTRIBUTION_OPTIONS[0].value;
        this.selectedAttributionOption = this.ATTRIBUTION_OPTIONS[0];
        // Periodicity
        this.performancePeriodicity = PerformancePeriodicity.THREE_YEARS;
        this.periodicityOptions = cloneDeep(FACTOR_ANALYSIS_ATTRIBUTION_PERIODICITY_OPTIONS);
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityType = this.eltRef.nativeElement.getAttribute('securityType');
        this.hasExportFeature = this.featureService.userHasFeatures([DATA_EXPORT_FEATURE]);
    }
    ngOnInit() {
        if (!window.USER.authenticated) {
            this.loading = false;
            return;
        }
        this.fetchFactorAttributionData();
    }
    ngOnDestroy() {
        if (this.fetchSubscription !== null)
            this.fetchSubscription.unsubscribe();
    }
    fetchFactorAttributionData() {
        this.loading = true;
        if (this.fetchSubscription !== null)
            this.fetchSubscription.unsubscribe();
        this.fetchHandler = this.securitiesService
            .getFactorAttributionData(this.securityId, this.performancePeriodicity, this.selectedAttribution)
            .pipe(shareReplay());
        this.fetchSubscription = this.fetchHandler.subscribe({
            next: (attributionData) => {
                this.formatBarChartData(attributionData);
                this.factorCoefficientRangeData = attributionData.factor_profile;
                this.categoryGroupName = attributionData.category_group_name;
            },
            error: () => {
                this.attributionBarChartData = {};
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
            },
        });
    }
    formatBarChartData(attributionData) {
        const keys = Object.keys(attributionData.data);
        const barChartData = new Array(keys.length);
        const coefficients = new Array(keys.length);
        const cssClasses = new Array(keys.length);
        for (let i = 0; i < keys.length; i += 1) {
            const factorValue = attributionData.data[keys[i]];
            barChartData[i] = { data: [Number(factorValue.value)], name: factorValue.label };
            coefficients[i] = factorValue.coefficient;
            cssClasses[i] = factorValue.css_class;
        }
        this.attributionBarChartData = { barChartData, coefficients, cssClasses };
    }
    updatePeriodicity(periodicity) {
        if (this.loading)
            return;
        this.performancePeriodicity = periodicity;
        this.fetchFactorAttributionData();
    }
    selectAttributionModeOption(option) {
        if (this.loading)
            return;
        this.selectedAttribution = option;
        this.selectedAttributionOption = this.ATTRIBUTION_OPTIONS.find((btn) => btn.value === this.selectedAttribution);
        this.fetchFactorAttributionData();
    }
    // PDF Exporting
    openPDFTitleModal() {
        this.pdfTitleModal.openModal();
    }
    export(title) {
        this.exportLoading = true;
        this.securitiesService
            .getFactorAttributionDataExport(this.securityId, title, this.performancePeriodicity, this.selectedAttribution)
            .subscribe({
            next: (response) => {
                downloadUrl(response.pdf_url);
                this.exportLoading = false;
            },
            error: () => {
                this.exportLoading = false;
            },
        });
    }
}
AttributionFactorAnalysisComponent.ɵfac = function AttributionFactorAnalysisComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionFactorAnalysisComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
AttributionFactorAnalysisComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionFactorAnalysisComponent, selectors: [["ycn-attribution-factor-analysis"]], viewQuery: function AttributionFactorAnalysisComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pdfTitleModal = _t.first);
    } }, standalone: false, decls: 23, vars: 25, consts: [["pdfTitleModal", ""], [1, "page-header", "row"], [1, "col"], [1, "page-title"], [1, "page-name"], [1, "col-auto"], [1, "form-inline"], [1, "d-flex"], [2, "font-weight", "400", "color", "grey", "margin-top", "2px", "font-size", ".857rem"], [3, "selectHandler", "options", "selectedObject"], [1, "col-auto", "align-self-end"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], [3, "updatePeriodicityHandler", "factorCoefficientRangeData", "categoryGroupName", "securityType", "selectedAttribution", "periodicityOptions", "performancePeriodicity"], [3, "updatePeriodicityHandler", "attributionBarChartData", "selectedAttribution", "periodicityOptions", "performancePeriodicity"], [3, "updatePeriodicityHandler", "securityName", "fetchHandler", "selectedAttribution", "periodicityOptions", "performancePeriodicity"], [3, "submitHandler", "defaultTitle", "submitButtonText"], [3, "loadingText", "modalTrigger"]], template: function AttributionFactorAnalysisComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4);
        i0.ɵɵtext(4, "Attribution by Factor Analysis");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "div", 8);
        i0.ɵɵtext(9, " VIEW ATTRIBUTION BY:\u00A0\u00A0 ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "ycn-radio-button-group", 9);
        i0.ɵɵlistener("selectHandler", function AttributionFactorAnalysisComponent_Template_ycn_radio_button_group_selectHandler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectAttributionModeOption($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 10)(12, "div", 6)(13, "button", 11);
        i0.ɵɵlistener("click", function AttributionFactorAnalysisComponent_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openPDFTitleModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(14, "svg", 12);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "span");
        i0.ɵɵtext(16, "Export");
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelementStart(17, "ycn-attribution-factor-profile", 13);
        i0.ɵɵlistener("updatePeriodicityHandler", function AttributionFactorAnalysisComponent_Template_ycn_attribution_factor_profile_updatePeriodicityHandler_17_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "ycn-attribution-factor-bar-chart", 14);
        i0.ɵɵlistener("updatePeriodicityHandler", function AttributionFactorAnalysisComponent_Template_ycn_attribution_factor_bar_chart_updatePeriodicityHandler_18_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "ycn-attribution-factor-scatter-plot", 15);
        i0.ɵɵlistener("updatePeriodicityHandler", function AttributionFactorAnalysisComponent_Template_ycn_attribution_factor_scatter_plot_updatePeriodicityHandler_19_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "ycn-pdf-title-modal", 16, 0);
        i0.ɵɵlistener("submitHandler", function AttributionFactorAnalysisComponent_Template_ycn_pdf_title_modal_submitHandler_20_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.export($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(22, "ycn-loading-modal", 17);
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("options", ctx.ATTRIBUTION_OPTIONS)("selectedObject", ctx.selectedAttributionOption);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", !ctx.hasExportFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-export");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("factorCoefficientRangeData", ctx.factorCoefficientRangeData)("categoryGroupName", ctx.categoryGroupName)("securityType", ctx.securityType)("selectedAttribution", ctx.selectedAttribution)("periodicityOptions", ctx.periodicityOptions)("performancePeriodicity", ctx.performancePeriodicity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("attributionBarChartData", ctx.attributionBarChartData)("selectedAttribution", ctx.selectedAttribution)("periodicityOptions", ctx.periodicityOptions)("performancePeriodicity", ctx.performancePeriodicity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("securityName", ctx.securityName)("fetchHandler", ctx.fetchHandler)("selectedAttribution", ctx.selectedAttribution)("periodicityOptions", ctx.periodicityOptions)("performancePeriodicity", ctx.performancePeriodicity);
        i0.ɵɵadvance();
        i0.ɵɵproperty("defaultTitle", "Factor Attribution Analysis")("submitButtonText", "Download");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loadingText", "Exporting PDF")("modalTrigger", i0.ɵɵpureFunction1(23, _c1, ctx.exportLoading));
    } }, dependencies: [i3.DisabledDirective, i4.IconDirective, i5.LoadingModalComponent, i6.PdfTitleModalComponent, i7.RadioButtonGroupComponent, i8.AttributionFactorBarChartComponent, i9.AttributionFactorProfileComponent, i10.AttributionFactorScatterPlotComponent], encapsulation: 2 });
